import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

/**
 * Handles the return trip from Emergent Google Auth.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      // Defer toast: sonner's <Toaster> subscribes after this mount effect
      setTimeout(() => toast.error("Session Google introuvable"), 0);
      navigate("/auth", { replace: true });
      return;
    }

    (async () => {
      try {
        const ref = localStorage.getItem("kynoria_ref") || null;
        const { data } = await api.post("/auth/google/session", {
          session_id: sessionId,
          referral_code: ref,
        });
        localStorage.removeItem("kynoria_ref");
        localStorage.setItem("parentia_token", data.token);
        // Clean the fragment
        try {
          window.history.replaceState(null, "", "/");
        } catch (e) {
          // ignore
        }
        await refresh();
        toast.success(`Bienvenue ${data.user.name} 💛`);
        navigate("/", { replace: true });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Connexion Google échouée");
        navigate("/auth", { replace: true });
      }
    })();
  }, [location, navigate, refresh]);

  return (
    <div className="min-h-screen grid place-items-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="mx-auto h-10 w-10 animate-spin text-[#23375E]" />
        <p className="mt-4 text-[#44506B]">Connexion en cours...</p>
      </div>
    </div>
  );
}
